var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"ac-icon",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M3 20H12L13.6 23H21C22.1 23 23 22.1 23 21V6C23 4.9 22.1 4 21 4H13.6L12 1H3C1.9 1 1 1.9 1 3V18C1 19.1 1.9 20 3 20ZM2.5 3C2.5 2.7 2.7 2.5 3 2.5H10.5V18.5H3C2.7 18.5 2.5 18.3 2.5 18V3Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }